import React from "react";

class ContactBanner extends React.Component {
  render() {
    return (
      <section className="header_section">
        <div className="bg-overlay" />
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-white text-center">
                <h2 className="font-weight-bold fonts-italic font-italic">
                  Contact Us
                </h2>
                <div className="home_divider mt-3 mb-3 mx-auto" />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ContactBanner;



// WEBPACK FOOTER //
// ./src/pages/contact/ContactBanner.js